// Platform settings (Admin). Today the one setting is how workflow ratings are weighed (D73).
import { WeightsCard } from "../ratings/WeightsCard";

export default function SettingsPage() {
  return (
    <div className="max-w-3xl">
      <WeightsCard />
    </div>
  );
}
